import { ConfirmSheet } from '@/components/ConfirmSheet'
import {
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentTitle,
} from '@/components/ModalSheet'

export interface UnlinkDocumentDialogProps {
  showing: boolean
  isPending: boolean
  onConfirm: () => unknown
  onDecline: () => unknown
}

/**
 * Confirms unlinking a document from a job.
 */
export function UnlinkDocumentDialog({
  showing,
  isPending,
  onConfirm,
  onDecline,
}: UnlinkDocumentDialogProps) {
  return (
    <ConfirmSheet
      yes="Unlink Document"
      danger
      showing={showing}
      isPending={isPending}
      onConfirm={onConfirm}
      onDecline={onDecline}
    >
      <ModalSheetContentBlock>
        <ModalSheetContentTitle>Unlink this document?</ModalSheetContentTitle>
        <ModalSheetContentDescription>
          This may result in some people being unable to view this document.
        </ModalSheetContentDescription>
      </ModalSheetContentBlock>
    </ConfirmSheet>
  )
}
